// extracted by mini-css-extract-plugin
export default {"profileVerification":"TopbarContainer_profileVerification__dHT-h"};